var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSm1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon front"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4592 1.66031C12.3261 1.55642 12.1621 1.5 11.9932 1.5C11.8243 1.5 11.6603 1.55642 11.5272 1.66031L0.75 10.0645L1.68203 11.2433L3 10.2156V19.5C3.00081 19.8975 3.15911 20.2786 3.44024 20.5597C3.72137 20.8409 4.10242 20.9991 4.5 21H19.5C19.8976 20.9992 20.2787 20.841 20.5599 20.5598C20.841 20.2787 20.9993 19.8976 21 19.5V10.2225L22.318 11.25L23.25 10.0711L12.4592 1.66031ZM13.5 19.5H10.5V13.5H13.5V19.5ZM15 19.5V13.5C14.9995 13.1023 14.8414 12.721 14.5602 12.4398C14.279 12.1586 13.8977 12.0004 13.5 12H10.5C10.1023 12.0004 9.721 12.1585 9.43978 12.4397C9.15856 12.721 9.0004 13.1023 9 13.5V19.5H4.5V9.04608L12 3.20358L19.5 9.05396V19.5H15Z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSm1);
export default __webpack_public_path__ + "static/media/sm1.315d0ece8ed29e21ad0914b79c438454.svg";
export { ForwardRef as ReactComponent };